
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24"
  },
  "children": [
    {
      "tag": "defs",
      "children": [
        {
          "tag": "clipPath",
          "attrsMap": {
            "id": "clip-path"
          },
          "children": [
            {
              "tag": "rect",
              "attrsMap": {
                "id": "矩形_11208",
                "data-name": "矩形 11208",
                "class": "cls-1",
                "width": "24",
                "height": "24",
                "transform": "translate(250 404)"
              }
            }
          ]
        }
      ]
    },
    {
      "tag": "g",
      "attrsMap": {
        "id": "蒙版组_248",
        "data-name": "蒙版组 248",
        "class": "cls-2",
        "transform": "translate(-250 -404)"
      },
      "children": [
        {
          "tag": "path",
          "attrsMap": {
            "id": "weibolu",
            "class": "cls-3",
            "d": "M18.05,0A.946.946,0,0,1,19,.941V14.118a.946.946,0,0,1-.95.941H17.1v.471a.473.473,0,0,1-.475.471H16.15a.473.473,0,0,1-.475-.471v-.471H3.325v.471A.473.473,0,0,1,2.85,16H2.375a.473.473,0,0,1-.475-.471v-.471H.95A.946.946,0,0,1,0,14.118V.941A.946.946,0,0,1,.95,0h17.1Zm0,12.235H.95v1.412a.473.473,0,0,0,.475.471h16.15a.473.473,0,0,0,.475-.471ZM12.825.941H1.425a.473.473,0,0,0-.475.471v9.882H12.825Zm4.75,0h-3.8V11.294H18.05V1.412a.473.473,0,0,0-.475-.471ZM15.913,8.471a.706.706,0,1,1-.713.706A.709.709,0,0,1,15.913,8.471ZM4.063,3.526a.429.429,0,0,1-.176.578A.974.974,0,0,0,3.9,5.937,1.888,1.888,0,0,1,4.988,7.606,1.851,1.851,0,0,1,4,9.213l-.1.061a.438.438,0,0,1-.589-.152.429.429,0,0,1,.139-.587l.018-.01a1.047,1.047,0,0,0,.652-.92,1.038,1.038,0,0,0-.641-.914,1.849,1.849,0,0,1-1.1-1.674,1.817,1.817,0,0,1,1-1.616l.1-.058A.438.438,0,0,1,4.063,3.526Zm6.966,0a.429.429,0,0,1-.176.578.974.974,0,0,0,.01,1.834,1.888,1.888,0,0,1,1.091,1.668,1.851,1.851,0,0,1-.987,1.608l-.1.061a.438.438,0,0,1-.589-.152.429.429,0,0,1,.139-.587l.018-.01a1.047,1.047,0,0,0,.651-.92,1.038,1.038,0,0,0-.641-.914,1.849,1.849,0,0,1-1.1-1.674,1.817,1.817,0,0,1,1-1.616l.1-.058a.438.438,0,0,1,.588.182Zm-3.483,0a.429.429,0,0,1-.176.578.974.974,0,0,0,.01,1.834,1.888,1.888,0,0,1,1.09,1.668,1.851,1.851,0,0,1-.986,1.608l-.1.061a.438.438,0,0,1-.589-.152.429.429,0,0,1,.139-.587l.018-.01a1.047,1.047,0,0,0,.651-.92,1.038,1.038,0,0,0-.641-.914,1.849,1.849,0,0,1-1.1-1.674,1.818,1.818,0,0,1,1-1.616l.1-.058a.438.438,0,0,1,.588.182Zm8.366,2.121a.706.706,0,1,1-.713.706A.709.709,0,0,1,15.913,5.647Zm0-2.824a.706.706,0,1,1-.713.706A.709.709,0,0,1,15.913,2.824Z",
            "transform": "translate(253 408)"
          }
        }
      ]
    }
  ]
})
    }
  